import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService, OptimoveService, routeActivationEndData$, FooterLinkType } from '@whitehatgaming/shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  headerVisible$: Observable<boolean>
  renderHeader: boolean = false;
  isLoggedInAsString = this.login.loggedIn ? 'true' : 'false';

  footerLinkTypes: FooterLinkType [] = [
    FooterLinkType.TERMS,
    FooterLinkType.COMPLAINTS_PROCEDURE,
    FooterLinkType.PROMO_TERMS,
    FooterLinkType.PRIVACY,
    FooterLinkType.AFFILIATES];

  constructor(
    private optimoveService: OptimoveService,
    public login: LoginService,
    private router: Router
  ) {
    if (window.location !== window.parent.location) {
      window.parent.location.href = window.location.href;
    } else {
      this.renderHeader = true;
    }
  }

  ngOnInit() {
    this.optimoveService.startOptimove();

    this.headerVisible$ = routeActivationEndData$(this.router).pipe(
      map(data => !data?.appHeaderHidden)
    );

  }
}
